<template>
  <div class="container">
    Use this page to assign a profile to the task. Make time for design.
    <p></p>
    You can also note the value YOU get from doing the task. This information is
    personal. It is not recorded on the corporate MIS.
    <p></p>
    Appreciating personal value is the best way of improving psychological
    contracts.
    <p></p>
    Once the profile is assigned go to the Dates page and visually adjust the
    complexity and duration. The values will appear here.
    <p></p>
    <!-- <div class="row" style="padding-top: 30px">
      <div class="col col-lg-3" style="text-align:left;">
        <h3>Add new item</h3>
      </div>
      <div class="col col-lg-4 offset-lg-4">
        <span>User: {{ user }}</span>
      </div>
      <div class="col col-lg-1">
        <button class="btn btn-warning" @click="logout()">Logout</button>
      </div>
    </div> -->
    <!-- <div>
      <form @submit="addTodo">
        <div class="row">
          <div class="col col-lg-4" style="text-align:left;">
            <label class="typo__label">Task Title</label>
            <input
              name="task"
              v-model="title"
              type="text"
              class="form-control"
              placeholder="Task Description"
            />
          </div>

          <div class="col col-lg-4" style="text-align:left;">
            <label class="typo__label">Work Profile</label>
            <multiselect
              v-model="profile"
              placeholder="Select a profile"
              label="title"
              track-by="title"
              :options="options"
              :option-height="104"
              :custom-label="customLabel"
              :show-labels="false"
            >
              <template slot="singleLabel" slot-scope="props" name="profile">
                <img
                  class="option__image"
                  :src="props.option.img"
                  alt="No Man’s Sky"
                />
                <span class="option__desc">
                  <span class="option__title" style="margin-left:10px">{{
                    props.option.title
                  }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <table>
                  <tr>
                    <td>
                      <img
                        class
                        :src="props.option.img"
                        alt="The empty class"
                        style="vertical-align:middle"
                      />
                    </td>
                    <td>
                      <div class="option__desc">
                        <span class="option__title" style="margin-left:10px;">{{
                          props.option.title
                        }}</span>
                        <br />
                        <span class="option__small" style="margin-left:10px;">{{
                          props.option.desc
                        }}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
            </multiselect>
          </div>

          <div class="col col-lg-1">
            <p></p>
            <input type="submit" value="Add" class="btn btn-success" />
          </div>
        </div>
      </form>
    </div> -->

    <div class="row" style="padding-top: 30px; text-align:left;">
      <div class="col col-lg-3">
        <h3>Selected items</h3>
      </div>
    </div>
    <div class="row" style="text-align:left;">
      <div class="col col-lg-4 column-heading">Work Note</div>
      <div class="col col-lg-4 column-heading">Profile</div>
      <div class="col col-lg-2 column-heading">Personal Value</div>
      <div class="col col-lg-2 column-heading">Comp/Dur</div>
      <!-- <div class="col col-lg-1 column-heading">Duration</div> -->
    </div>
    <p></p>

    <div id="val-list" style="text-align: left;">
      <article v-for="valdo in approvedItems" :key="valdo['.name']">
        <div>
          <!-- <img style="margin: 10px" :src="comic.image" height="291px" width="192px"> -->
          <div class="row">
            <div class="col col-lg-4">
              <p>{{ valdo.name }}</p>
            </div>
            <!-- @input="updateProfile(valdo['.key'], valdo.profile)" -->
            <div class="col col-lg-4">
              <multiselect
                v-model="valdo.profile"
                @input="updateProfile(valdo, valdo.profile)"
                placeholder="Select a profile"
                label="name"
                :options="options"
                :option-height="104"
                :custom-label="customLabel"
                :show-labels="false"
              >
                <template slot="singleLabel" slot-scope="props" name="profile">
                  <img
                    class="option__image"
                    :src="props.option.img"
                    alt="Missing image"
                  />
                  <span class="option__desc">
                    <span class="option__title" style="margin-left:10px">{{
                      props.option.title
                    }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <table>
                    <tr>
                      <td>
                        <img
                          class
                          :src="props.option.img"
                          alt="Missing Image"
                          style="vertical-align:middle"
                        />
                      </td>
                      <td>
                        <div class="option__desc">
                          <span
                            class="option__title"
                            style="margin-left:10px;"
                            >{{ props.option.title }}</span
                          >
                          <br />
                          <span
                            class="option__small"
                            style="margin-left:10px;"
                            >{{ props.option.desc }}</span
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </template>
              </multiselect>
            </div>
            <div class="col col-lg-2">
              <textarea
                name="valueDesc"
                id="valueDesc"
                v-model="valdo.description"
                cols="18"
                rows="1"
                @blur="updateValue(valdo['.key'], valdo.description)"
              ></textarea>
            </div>
            <div class="col col-lg-2">
              <!-- <input
                type="text"
                style="font-size: 12pt; height: 40px; width:50px; text-align:right;"
                v-model="valdo.complexity"
                @blur="updateComplexity(valdo['.key'], valdo.complexity)"
              > -->
              <span class="complexity">{{ valdo.complexity }}</span>
              <span> | </span>
              <span class="duration">{{ valdo.duration }}</span>
            </div>
            <!-- <div class="col col-lg-1"> -->
            <!-- <input
                type="text"
                style="font-size: 12pt; height: 40px; width:50px; text-align:right; "
                v-model="valdo.duration"
                @blur="updateDuration(valdo['.key'], valdo.duration)"
              > -->

            <!-- </div> -->
            <!-- <div class="col col-lg-1">
              <button class="salve" @click="showSALVe(valdo['.key'])">-</button>
              <button class="del" @click="deleteValToDo(valdo['.key'])">-</button>
            </div> -->
          </div>
          <!-- <div class="row">
            <Salve></Salve>
          </div> -->
          <!-- <p>{{ valdo.profile }}</p> -->
        </div>
      </article>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import { db } from "../main";
// import { valdosRef } from "../main";
import Multiselect from "vue-multiselect";
import Salve from "../components/Salve";

export default {
  name: "profiler",
  components: {
    Multiselect,
    Salve
  },
  // firebase() {
  //   return {
  //     valdos: valdosRef
  //   };
  // },
  data() {
    return {
      user: "",
      valdos: [],
      selected: "",
      title: "",
      profile: "",
      options: [
        {
          title: "Fast No Value",
          desc: "What is the point? - automate!",
          img: require("@/assets/guitar.png"),
          value: 1
        },
        {
          title: "Enabler",
          desc: "Little work for long tail value",
          img: require("@/assets/drum.png"),
          value: 2
        },
        {
          title: "Medium effort & value",
          desc: "Scan and design, medium effort with return",
          img: require("@/assets/strings.png"),
          value: 3
        },
        {
          title: "Sustained Value",
          desc: "Scan, no design and ongoing value",
          img: require("@/assets/synth-texture.png"),
          value: 4
        }
      ]
    };
  },
  methods: {
    customLabel({ title, desc }) {
      return `${title} – ${desc}`;
    },
    updateProfile(valdo, profile) {
      console.log("Updating PROFILE ", valdo, profile);

      let payload = { index: valdo.name, profileValue: profile.value };

      this.$store.dispatch("updateProfile", payload);
    },
    updateComplexity(valdo, complexity) {
      console.log("Updating Complexity");
    },
    updateValue(valdo, valDesc) {
      console.log("Updating Personal Value");
    },
    updateDuration(valdo, duration) {
      console.log("Updating Duration");
    }
  },
  // addTodo(e) {
  //     e.preventDefault();
  //     let user = firebase.auth().currentUser;
  //     this.user = user.email;
  //     const createdAt = new Date();
  //     console.log(user.email, createdAt);
  //     db.ref("valdos").push({
  //       user: user.email,
  //       title: this.title,
  //       profile: this.profile,
  //       completed: false,
  //       complexity: "",
  //       duration: "",
  //       description: "",
  //       createdAt: createdAt.toDateString()
  //     });
  //     this.title = "";
  //     this.profile = "";
  //   },
  //   showSALVe(key) {
  //     console.log("In SALVe");
  //   },
  //   deleteValToDo(key) {
  //     console.log(key);
  //     valdosRef.child(key).remove();
  //     // toastr.success('Business removed successfully')
  //   },
  //   logout: function() {
  //     firebase
  //       .auth()
  //       .signOut()
  //       .then(() => {
  //         this.$router.replace("login");
  //       });
  //   },
  //   updateComplexity(valdo, valcomp) {
  //     console.log("Updating line ", valdo);
  //     // update the entry in the database
  //     db.ref("valdos/" + valdo).update(
  //       {
  //         complexity: valcomp
  //       },
  //       function(error) {
  //         if (error) {
  //           console.log(">>> FB update ERROR ", error);
  //         } else {
  //           // console.log("Take a look behind the scenes");
  //         }
  //       }
  //     );
  //   },
  //   updateDuration(valdo, valdur) {
  //     console.log("Updating line ", valdo);
  //     // update the entry in the database
  //     db.ref("valdos/" + valdo).update(
  //       {
  //         duration: valdur
  //       },
  //       function(error) {
  //         if (error) {
  //           console.log(">>> FB update ERROR ", error);
  //         } else {
  //           // console.log("Take a look behind the scenes");
  //         }
  //       }
  //     );
  //   },

  //   updateValue(valdo, valueDesc) {
  //     console.log("Updating line ", valdo);
  //     // update the entry in the database
  //     db.ref("valdos/" + valdo).update(
  //       {
  //         description: valueDesc
  //       },
  //       function(error) {
  //         if (error) {
  //           console.log(">>> FB update ERROR ", error);
  //         } else {
  //           // console.log("Take a look behind the scenes");
  //         }
  //       }
  //     );
  //   }
  // },
  created() {
    // let user = firebase.auth().currentUser;
    // this.user = user.email;
    // console.log(this.user);
    // this.$bindAsArray("valdos", valdosRef);
  },
  computed: {
    storeTodos() {
      // this.todos = this.$store.state.todos
      // console.log("Profile Todos", this.$store.state.todos.items);
      return this.$store.state.todos.items;
    },
    approvedItems() {
      return this.$store.getters.approvedItems;
    }
  },
  mounted() {
    var _approvedItems = this.$store.state.todos.items;
    // console.log("Mounted Approved ", _approvedItems);
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.column-heading {
  font-weight: bold;
}
.btn_black {
  display: inline-block;
  border: none;
  background: #555;
  color: #fff;
  padding: 7px 20px;
  cursor: pointer;
}
.typo__label {
  text-align: left;
  text-decoration: bold;
}
.todo-item {
  background: #f4f4f4;
  padding: 10px;
  border-bottom: 1px #ccc dotted;
}

.is-complete {
  text-decoration: line-through;
}

.del {
  background: #ff0000;
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
  float: right;
}
.salve {
  background: #00ccffcc;
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
  float: right;
}
.complexity {
  text-emphasis: bold;
  color: red;
}
.duration {
  text-align: right;
}
</style>
